import { useEffect, useRef } from "react";

export function parseNormalize(str) {
  if (typeof str !== "string") return str;

  // Remove espaços extras no início e fim
  let normalized = str.trim();

  // Substitui aspas simples por aspas duplas
  normalized = normalized.replace(/'/g, '"');

  // Remove vírgulas extras antes de fechar objetos/arrays
  normalized = normalized.replace(/,\s*([}\]])/g, "$1");

  // Escapa caracteres de controle (ex: quebras de linha)
  normalized = normalized.replace(/\n/g, "\\n").replace(/\r/g, "\\r");

  return JSON.parse(normalized);
}

export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
